export function dataUrlToBlob(dataUrl) {
  const [meta, base64] = dataUrl.split(",");
  const mime = meta.match(/:(.*?);/)[1];
  const binary = atob(base64);
  const arr = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) arr[i] = binary.charCodeAt(i);
  return new Blob([arr], { type: mime });
}

export function dataUrlToPngFile(dataUrl, filename = "signature.png") {
  const blob = dataUrlToBlob(dataUrl);
  return new File([blob], filename, { type: "image/png" });
}
